import {ISortElements} from "src/store/actions";
import {IAppState, IFruit} from "src/store/models";
import {sortBoxesReducer} from "src/store/reducers/sorting/sortBoxesReducer";
import {sortFruitsReducer} from "src/store/reducers/sorting/sortFruitsReducer";

export const sortElementsReducer = (state: IAppState, action: ISortElements) => {
    const {shelfId} = action.payload;
    const {boxesIds} = state.shelves[shelfId];

    const fruitsModel = boxesIds
        .map(boxId => state.boxes[boxId].fruitsIds
            .map(fruitId => {
                const {kind, size} = state.fruits[fruitId];
                return {kind, size, fruitId}
            })
        )
        .reduce((acc, cur) => [...acc, ...cur], [])
        .sort((a, b) => a.size - b.size)
        .reduce((acc, curr) => ({...acc, [curr.kind]: [...(acc[curr.kind] || []), curr]}), {});

    const sortedByLen = Object
        .keys(fruitsModel)
        .map(key => fruitsModel[key])
        .sort((a, b) => b.length - a.length);

    const boxesWithUpdatedIds = boxesIds
        .map((boxId, index) => {
            const fruitsWithUpdatedIds = index !== boxesIds.length - 1 ?
                sortedByLen.shift() || []:
                [...sortedByLen].reduce((a, c) => [...a, ...c], []);
            return {
                ...state.boxes[boxId],
                fruitsIds: fruitsWithUpdatedIds.map((fruit: IFruit & {fruitId: string}) => fruit.fruitId),
                selfId: boxId
            }
        });

    return {
        ...state,
        boxes: sortBoxesReducer(state.boxes, boxesWithUpdatedIds),
        fruits: sortFruitsReducer(state.fruits, boxesWithUpdatedIds)
    };
};


// WEBPACK FOOTER //
// ./src/store/reducers/sorting/sortElementsReducer.ts